module.exports = __webpack_public_path__ + "@/assets/img/calendario.5bdbd800.png";